/* tslint:disable */
import * as moment from "moment";

export default class DateTimeHelper {
    public static readonly ShortDateFormat: string = "DD/MM/YYYY";
    public static readonly DateFormat: string = "MMM DD YYYY";
    public static readonly FullDateFormat: string = "dddd Do MMMM YYYY";
    public static readonly DateTimeStampFormat24Hour: string = "DD/MM/YYYY @ HH:mm:ss";
    public static readonly DateTimeStampFormat12Hour: string = "DD/MM/YYYY @ hh:mm:ss A";
    public static readonly TimeFormat: string = "h:mm a";
    public static readonly UppercaseTimeFormat: string = "h:mm A";
    public static readonly LongTimeFormat: string = "HH:mm";
    public static readonly ServerDateFormat: string = "YYYY-MM-DD";

    public static toShortDateString(date: Date): string {
        return moment(date).format(DateTimeHelper.ShortDateFormat);
    }

    public static toDateString(date: Date): string {
        return moment(date).format(DateTimeHelper.DateFormat);
    }

    public static toFullDateString(date: Date): string {
        return moment(date).format(DateTimeHelper.FullDateFormat);
    }

    public static toDateTimeStamp24Hour(date: Date): string {
        return moment(date).format(DateTimeHelper.DateTimeStampFormat24Hour);
    }

    public static toDateTimeStamp12Hour(date: Date): string {
        return moment(date).format(DateTimeHelper.DateTimeStampFormat12Hour);
    }

    public static toTimeString(date: Date): string {
        return moment(date).format(DateTimeHelper.TimeFormat);
    }

    public static toLongTimeString(date: Date): string {
        return moment(date).format(DateTimeHelper.LongTimeFormat);
    }

    public static fromShortDateString(dateString: string): Date {
        return moment(dateString,DateTimeHelper.ShortDateFormat).toDate();
    }

    public static isValid(date: any): boolean {

        if (!date || date === "0001-01-01T00:00:00") {
            return false;
        }
        return true;
    }

    public static toServerDateFormatString(date: Date): string {
        return moment(date).format(DateTimeHelper.ServerDateFormat);
    }
}
